import type { ComponentProps } from 'react';

import { CoreProviders } from '@packages/core/core-providers';

import { QueryProvider } from './query-provider';
import { ThemedChildren } from './theme';

/**
 * The root node to be rendered which includes various context providers but no UI elements itself
 * @param children - content of application
 */
export const Root = ({
  children,
  ...props
}: ComponentProps<typeof ThemedChildren>) => (
  <CoreProviders>
    <ThemedChildren {...props}>
      <QueryProvider>{children}</QueryProvider>
    </ThemedChildren>
  </CoreProviders>
);
